import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { TextField, DatePicker } from "redux-form-material-ui";
import { FlatButton, List, ListItem, Avatar } from "material-ui";
import FontIcon from "material-ui/FontIcon";
import VerticalListFields from "../../components/VerticalListFields/VerticalListFields";

class PagoBoleta extends Component {
	constructor(props) {
		super(props);
		let dateFrom = new Date();
		let dateUntil = new Date();
		dateUntil.setDate(dateUntil.getDate() + 45);
		this.state = {
			valueTextField: "",
			dateFrom: dateFrom,
			dateUntil: dateUntil,
			dateF: dateFrom,
			dateU: dateUntil,
			imagenesArray: [],
			uploadWarning: false,
			isMaxCount: false,
			showLoading: false,
			occupation: 0
		};
	}

	componentWillMount() {
		this.props.initialize({
			concepto: "Aportes Sindicales período 01/18",
			total: "$ 15.712,00",
			date: new Date("Feb 10, 2018")
		});
	}

	onSubmit(values) {}

	render() {
		return (
			<div>
				<div>
					<form>
						<div className="columns-row-container">
							<VerticalListFields
								titleText="Nuevo Pago"
								titleClass="title-papercard-primary"
								paperClass="papercard"
								contentClass="content-papercard-around"
							>
								<div className="columns-row-between">
									<Field
										name="concepto"
										component={TextField}
										floatingLabelText="Concepto"
										floatingLabelFixed
										style={{ width: 400, marginRight: 30 }}
										disabled
									/>
									<Field
										name="total"
										component={TextField}
										floatingLabelText="Total a Pagar"
										floatingLabelFixed
										style={{ marginRight: 30 }}
										disabled
									/>
									<Field
										name="date"
										component={DatePicker}
										className="flex-column"
										floatingLabelText="Fecha de Vencimiento"
										floatingLabelFixed
										hintText="dd/mm/aaaa"
										format={null}
										disabled
										DateTimeFormat={Intl.DateTimeFormat}
										locale="es-ES"
									/>
								</div>
								<List style={{ width: 300 }}>
									<ListItem
										key={1}
										primaryText="Rapipago"
										rightIcon={
											<FontIcon className="material-icons">
												arrow_forward
											</FontIcon>
										}
										leftAvatar={
											<Avatar src="https://www.about-payments.com/logo/300/225/680" />
										}
									/>
									<ListItem
										key={2}
										primaryText="PagoMisCuentas"
										rightIcon={
											<FontIcon className="material-icons">
												arrow_forward
											</FontIcon>
										}
										leftAvatar={
											<Avatar src="http://www.edesur.com.ar/files/images/logo_pago_mis_cuentas.png" />
										}
									/>
									<ListItem
										key={3}
										primaryText="MercadoPago"
										rightIcon={
											<FontIcon className="material-icons">
												arrow_forward
											</FontIcon>
										}
										leftAvatar={
											<Avatar src="https://www.tarjetamercadopago.com.mx/assetsv3/images/logo_tarjetamercadopago_small.png" />
										}
									/>
									<ListItem
										key={4}
										primaryText="Deposito bancario"
										rightIcon={
											<FontIcon className="material-icons">
												arrow_forward
											</FontIcon>
										}
										leftAvatar={
											<Avatar src="https://cdn4.iconfinder.com/data/icons/business-4/500/bank_building_business_courthouse_economy_finance_investment_loan_management_office-512.png" />
										}
										onClick={() =>
											window.open(
												"https://firebasestorage.googleapis.com/v0/b/vault-react-template-18d35.appspot.com/o/BoletaPago.pdf?alt=media&token=1c671c39-31c0-47f6-b8d3-5406f19ed301",
												"_self"
											)
										}
									/>
								</List>
							</VerticalListFields>
						</div>
						<div className="top20 text-right">
							{/* <RaisedButton
								label="Aceptar"
								primary
								style={{ margin: 5 }}
								onClick={handleSubmit(this.onSubmit.bind(this))}
							/> */}
							<FlatButton
								label="Cancelar"
								href="/ABMMain"
								backgroundColor={"rgba(153, 153, 153, 0.1)"}
								style={{ margin: 5 }}
							/>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

export default reduxForm({
	form: "PagoBoleta"
})(PagoBoleta);



// WEBPACK FOOTER //
// ./src/screens/Boleta/PagoBoleta.js